import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal, Signal } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Card } from '../models/card.model';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { CardType, ItemType } from '../types/item-type.type';

@Injectable({
  providedIn: 'root'
})
export class ServiceCardsService {

  private cards: Card[] = [];
  //private cards$: Observable<Card[]> = of(this.cards);

  private card: Card = new Card(0, "", "", "0000", false, "");

  public activity: Signal<ItemType[]> = signal([
    { value: 0, name: "Nieaktywna" },
    { value: 1, name: "Aktywna" }
  ]);

  public types: Signal<CardType[]> = signal([
    { value: 'SERVICE_CARD', name: "Karta serwisowa" },
    { value: 'INTEGRATION_CARD', name: "Karta integracyjna" }
  ]);
  

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router

  ) { }

  fetchCards() {
    const endpoint = environment.apiUrl + "/api/cards";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.get<Card[]>(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  getCards(): Card[] {
    return this.cards;
  }

  getCurrentCard(): Card {
    return this.card;
  }

  setCard(card: Card) {
    this.card = card;
  }

  addCard(card: Card) {
    const endpoint = environment.apiUrl + "/api/cards";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.post<Card>(endpoint, card, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  updateCard(card: Card) {
    const endpoint = environment.apiUrl + "/api/cards/" + card.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.put<Card>(endpoint, card, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  deleteCard(id: number) {
    const endpoint = environment.apiUrl + "/api/cards/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.delete<Card>(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }

  generateQrCode(id: number) {
    const endpoint = environment.apiUrl + "/api/cards/" + id + "/qr";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()
    return this.http.get<Card>(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
  }


}
